import PropTypes from "prop-types";
import {
  ONLY_NUM_ALLOWED,
  PrimaryFormTextField,
} from "react-common-ui-library";
import {
  LICENSE_NUMBER_HELPER_TEXT,
  LICENSE_NUMBER_LABEL,
  LICENSE_NUMBER_REQUIRED_ERROR,
  PROF_LICENSE_NO,
} from "../../../Constants/ProviderAndCertifierAccountCreationConstants";

/**
 * @description Displays the Professional Lisence Number form input
 * @returns {ReactNode} Renders the Professional Lisence Number input to the user
 */
export const ProfessionalLicenseNumber = ({ hasProfLicenseNo }) => {
  return (
    <PrimaryFormTextField
      formProps={{
        name: PROF_LICENSE_NO,
        rules: {
          required: hasProfLicenseNo && LICENSE_NUMBER_REQUIRED_ERROR,
          maxLength: {
            value: 8,
            message: LICENSE_NUMBER_REQUIRED_ERROR,
          },
        },
      }}
      labelProps={{
        labelText: LICENSE_NUMBER_LABEL,
        required: hasProfLicenseNo,
      }}
      fieldProps={{
        restrictionPattern: ONLY_NUM_ALLOWED,
      }}
      helperTextProps={{
        helperText: LICENSE_NUMBER_HELPER_TEXT,
      }}
    />
  );
};

ProfessionalLicenseNumber.propTypes = {
  hasProfLicenseNo: PropTypes.string.isRequired,
};
